import React, { Component } from "react";
import {
    Card,
    Row,
    Col,
    Button,
    Input,
    Table
} from "reactstrap";
import { Link } from 'react-router-dom'
import LessonCard from "../LessonCard";
import DeleteButton from "../AuthorUIComponents/DeleteButton";
import Filter from "../Filter";
import {
  sortableHandle,
  sortableContainer,
  sortableElement
} from "react-sortable-hoc";
import arrayMove from "array-move";

const handleSortStart = ({ node }) => {
  const tr = document.getElementById("drag-row").getElementsByTagName("tr");
  const containerWidth = document.getElementsByClassName(
    "items-bank-left-container"
  )[0].offsetWidth;
  let { width } = tr[0].getBoundingClientRect();
  tr[0].style.clip = `rect(0px, ${containerWidth}px, 55px, 0px)`;
};

const DragHandle = sortableHandle(() => <span className="drag-handle" />);
const SortableItem = sortableElement(
  ({
    value,
    index,
    lastItem,
    reArrange,
    onSortEnd,
    addItems,
    previewItem,
    simulateItem,
    handleDelete
  }) => {
    return (
      <React.Fragment>
        <tr>
          {reArrange && (
            <td>
              <DragHandle />
              <Input
                className="item-input"
                onChange={this.handleOrderChange}
                value={value.index}
              />
              <span className="lesson-arrange-arrows arrange-arrows">
                {index > 0 && (
                  <span
                    onClick={() =>
                      onSortEnd({
                        oldIndex: index,
                        newIndex: Number(index) - 1
                      })
                    }
                    className="lesson-arrange-arrow-up"
                  />
                )}
                {Number(index) !== Number(lastItem) - 1 && (
                  <span
                    onClick={() =>
                      onSortEnd({
                        oldIndex: index,
                        newIndex: Number(index) + 1
                      })
                    }
                    className="lesson-arrange-arrow-down"
                  />
                )}
              </span>
              <DeleteButton
                handleDelete={handleDelete}
                index={index}
                item={value}
              />
            </td>
          )}

          <td>{value.itemCode}</td>
          <td>{value.itemType}</td>
          <td>{value.nodes}</td>
          <td>{value.tags}</td>
          <td>
            <div
              className="preview-td"
              dangerouslySetInnerHTML={{ __html: value.preview }}
            />
          </td>
        </tr>
        {!reArrange && (
          <div id={`row-side-menu-${index}`} className="row-side-menu">
            <Button onClick={() => simulateItem()} className="icon-btn">
              <i className="screen-eye-icon" />
            </Button>
            <Button onClick={() => previewItem()} className="icon-btn">
              <i className="preview-icon" />
            </Button>
          </div>
        )}
      </React.Fragment>
    );
  }
);
const SortableContainer = sortableContainer(({ children }) => {
  return <tbody>{children}</tbody>;
});

export default class LessonItemBank extends Component {
  state = {
    addItemMenu: false,
    previewItem: false,
    simulateItem: false,
    reArrangeActive: false,
    dummyData: [],
    itemTableData: [],
    addItemCardData: [],
    singleItem: null
  };
  componentDidMount() {
    // this.exampleData()
    /* <tr onMouseOver={() => {
                document.getElementById(`row-side-menu-${index}`).style.display = "block";
            }}
                onMouseLeave={() => {
                    document.getElementById(`row-side-menu-${index}`).style.display = "none";
                }}> */
    let dummyData = [];

    for (let index = 1; index <= 10; index++) {
      dummyData.push({
        index,
        itemCode: `ACT-E-Q${index}`,
        itemType: "Multiple Choice",
        preview: `Oh, king eh? Very nice. 
                            And how'd you get that, 
                            eh? By exploiting the workers. 
                            <span className='underlined_item'>By hanging on to outdated</span> imperialist dogma 
                            which perpetuates the economic and social differences 
                            in our society. If there's ever gonna be any progress...`,
        tags: "hard-question, mess-these-kids-up, questionable-answer",
        nodes: `Writer's Goal`,
        answerChoices: {
          answer001: "Bring out your dead",
          answer002: `Well you can't expect to wield supreme executive power just 'cause some watery tart threw a sword at you!`,
          answer003: `Come back here and take what's coming to you. I'll bite your legs off!`,
          answer004: `All right, all right, not biscuits, but lets kill him anyway.`
        }
      });
    }

    this.setState({
      dummyData: dummyData,
      itemTableData: dummyData,
      addItemCardData: dummyData
    });
  }
  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(({ itemTableData }) => ({
      itemTableData: arrayMove(itemTableData, oldIndex, newIndex)
    }));
    console.log(oldIndex, newIndex);
  };
  rearrangeToggle = () => {
    this.setState({
      reArrangeActive: !this.state.reArrangeActive
    });
  };
  deleteRow = item => {
    const { itemTableData } = this.state;
    this.setState({
      itemTableData: itemTableData.filter(val => val.itemCode !== item.itemCode)
    });
  };
  showSideIcons = show => {
    if (show) {
      this.setState({ sideIcons: true });
    } else {
      this.setState({ sideIcons: false });
    }
  };
  itemsFilter = (e, type) => {
    const { dummyData } = this.state;
    e.target.value !== ""
      ? this.setState({
          [type]: dummyData.filter(
            val =>
              val.itemCode
                .toLowerCase()
                .search(e.target.value.toLowerCase()) !== -1
          )
        })
      : this.setState({
          [type]: dummyData
        });
  };

  tableScrollHandle = e => {
    [...document.getElementsByClassName("row-side-menu")].map(
      ele =>
        (ele.style.transform = `translate(0px, -${e.target.scrollTop + 50}px)`)
    );
  };
  render() {
    const {
      reArrangeActive,
      addItemMenu,
      simulateItem,
      previewItem,
      sideIcons,
      addItemCardData,
      itemTableData,
      singleItem
    } = this.state;
    return (
      <React.Fragment>
        <LessonCard
          iconClass="items-icon"
          heading="Item Bank"
          isCollapsable={true}
          headerButtons={[
            <Button className="icon-btn" onClick={this.rearrangeToggle}>
              <i
                className={`icon-rearrange-icon-white ${
                  reArrangeActive ? "rearrange-active" : ""
                }`}
              />
            </Button>,
            <Button className="icon-btn">
              <i className="icon-preview-icon" />
            </Button>,
            <Button
              className={`add-btn ${addItemMenu ? "active" : ""}`}
              onClick={this.props.addItems}
            >
              + Add Items
            </Button>
          ]}
        >
              <Filter
                onChg={e => this.itemsFilter(e, "itemTableData")}
              />
          <div className="table-container">
            <div
              className="items-bank-left-container"
              onScroll={this.tableScrollHandle}
            >
              <Table striped hover className="items-bank-table">
                {/* <div className='dragging-row'></div> */}
                <div id="drag-row" />
                <thead className="card-header">
                  <tr>
                    {reArrangeActive && <th>Rearrange Actions</th>}
                    <th>Item Code</th>
                    <th>Item Type</th>
                    <th>Nodes</th>
                    <th>Tags</th>
                    <th>Preview</th>
                  </tr>
                </thead>
                <SortableContainer
                  onSortStart={handleSortStart}
                  helperContainer={document.getElementById("drag-row")}
                  lockToContainerEdges
                  useDragHandle
                  lockAxis={"y"}
                  helperClass={"dragging-row"}
                  onSortEnd={this.onSortEnd}
                >
                  {itemTableData.map((value, index) => (
                    <SortableItem
                      reArrange={reArrangeActive}
                      key={`item-${index}`}
                      index={index}
                      lastItem={itemTableData.length}
                      value={value}
                      onSortEnd={this.onSortEnd}
                      addItems={this.props.addItems}
                      simulateItem={this.props.simulateItem}
                      previewItem={this.props.previewItem}
                      handleDelete={this.deleteRow}
                    />
                  ))}
                </SortableContainer>
              </Table>
            </div>
          </div>
        </LessonCard>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorLesson/LessonItemBank.js